import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { App } from './App';

import { store, persistor } from './store';
import { requestPersistence } from './helpers/persistence';
requestPersistence();

const root = createRoot(document.getElementById('app'));
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>
);
